import { MacroCategoriaSal } from './macro-categoria-sal';

export class CategoriaSal{
    id:number;
    titolo:string; 
    macroCategoria:MacroCategoriaSal;     
}